import styled from 'styled-components';

// 준비/확정이 같은 컴포넌트를 공유하므로 상단 배너로 현재 화면을 구분한다.
export const ModeBanner = {
    Container: styled.div`
        display: flex;
        align-items: center;
        /* 좁은 폭에서 제목이 글자 단위로 쪼개지지 않도록 줄바꿈을 허용한다 */
        flex-wrap: wrap;
        gap: 6px 10px;
        padding: 12px 16px;
        margin-bottom: 14px;
        border-radius: 12px;
        border: 1px solid transparent;

        &.prepare {
            background: #eff6ff;
            border-color: #bfdbfe;
        }
        &.confirm {
            background: #f0fdf4;
            border-color: #bbf7d0;
        }

        .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            flex-shrink: 0;
        }
        &.prepare .dot { background: #2563eb; }
        &.confirm .dot { background: #16a34a; }

        .title {
            font-size: 14px;
            font-weight: 800;
            letter-spacing: -0.01em;
            /* '파레트 준비'가 두 줄로 쪼개지지 않게 고정 */
            white-space: nowrap;
        }
        &.prepare .title { color: #1d4ed8; }
        &.confirm .title { color: #15803d; }

        .desc {
            flex: 1 1 auto;
            min-width: 0;
            font-size: 12px;
            font-weight: 600;
            color: #64748b;
            line-height: 1.45;
            /* 한글이 어절 중간에서 끊기지 않도록 */
            word-break: keep-all;
        }

        /* 모바일/태블릿에서는 설명을 항상 다음 줄로 내려 제목 줄을 보존한다 */
        @media all and (max-width: 992px) {
            .desc {
                flex-basis: 100%;
            }
        }
    `,
}

export const Body = {
    Container: styled.div`
        padding: 0 10px;
        padding-top: 10px;
        padding-bottom: 100px;
    `,
    Wrapper: styled.div`
        display: flex;
        gap: 10px;
        flex-direction: row;

        @media all and (max-width:992px){
            flex-direction: column;
            gap: 30px;
        }
    `,
    SaveButtonWrapper: styled.div`
        margin-top: 20px;
        button{
            width: 200px;
            margin-left: auto;
            background: var(--purpleColor1);
            border: none;
            color: #fff;
        }
    `,
}

export const Table = {
    Container: styled.div`
        width: auto;
        flex:1;
    `,
    EventButtons: styled.div`
        margin-bottom: 10px;
        display: flex;
        gap: 6px;
        justify-content: space-between;
        button{
            width: auto;
            padding: 0 12px;
            height: 32px;
            font-size: 12px;
            font-weight: 700;
            border-radius: 8px;
            background: var(--blueColor1);
            color: #fff;
            border: none;
            transition: all .2s;

            &:hover{ filter: brightness(0.95); }

            &.delete{
                background: var(--redColor1);
            }
        }
    `,
    MoveConfirmButton: styled.button`
        width: auto;
        padding: 0 12px;
        height: 30px;
        font-size: 12px;
        font-weight: 700;
        border: none;
        border-radius: 8px;
        background: #16a34a;
        color: #fff;
        cursor: pointer;
        transition: all .2s;

        &:hover { background: #15803d; }

        /* 확정 → 준비로 내보내기 */
        &.toPrepare {
            background: #2563eb;
            &:hover { background: #1d4ed8; }
        }
    `,
    Wrapper: styled.div`
        width: 100%;
        height: 400px;
        overflow: auto;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    `,
    StyledTable: styled.table`
        width: 100%; // Total of all column widths
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
    `,
    ColumnGroup: styled.colgroup`
    `,
    TableHeader: styled.thead`
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #f0f4f8;
    `,
    HeaderRow: styled.tr`
        &:first-child {
            th {
                padding: 10px 8px;
                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                border-bottom: 1px solid #e2e8f0;
            }
        }

        &:last-child {
            th {
                padding: 10px 8px;
                font-size: 11px;
                border-bottom: 2px solid #cbd5e0;
            }
        }
    `,
    HeaderCell: styled.th`
        text-align: left;
        color: #4a5568;
        font-weight: 600;

        .rearrangeButton{
            height: 20px;
            width: auto;
            font-size: 12px;
            padding: 0 10px;
        }
    `,
    TableBody: styled.tbody`
        /* Remove the alternating row color here */
    `,
    TableRow: styled.tr`
        transition: background-color 0.2s;
        cursor: pointer;

        &:hover {
            background-color: #f1f5f9;
        }

        &.selected{
            background-color: #dbeafe;
            box-shadow: inset 3px 0 0 #2563eb;
        }

        /* 확정으로 넘어간 아이템: 흐리게 + 선택 불가 */
        &.locked{
            cursor: default;
            opacity: 0.45;
            background-color: #f8fafc;

            &:hover {
                background-color: #f8fafc;
            }
        }
    `,
    BulkSelectButton: styled.button`
        margin-top: 4px;
        height: 24px;
        padding: 0 8px;
        border: 1px solid #c7d2fe;
        border-radius: 6px;
        background: #eef2ff;
        color: #4f46e5;
        font-size: 10px;
        font-weight: 700;
        white-space: nowrap;
        cursor: pointer;
        transition: all .15s;

        &:hover { background: #e0e7ff; }
    `,
    ConfirmedBadge: styled.span`
        display: inline-flex;
        align-items: center;
        padding: 1px 8px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 700;
        white-space: nowrap;
        background: #dcfce7;
        color: #16a34a;
    `,
    TableCell: styled.td`
        padding: 10px 8px;
        border-bottom: 1px solid #e2e8f0;
        color: #2d3748;
        font-size: 11px;

        &.bold{
            font-weight: 700;
        }

        & .handlerButton{
            height: 30px;
            width: auto;
            padding: 0 10px;
            background: var(--blueColor1);
            border: none;
            color: #fff;
            font-size: 11px;

            &.status{
                &.loading{
                    background: var(--yellowColor1-light);
                    color: var(--yellowColor1);
                }
                &.prepared{
                    background: var(--blueColor2-light);
                    color: var(--blueColor2);
                }
                &.done{
                    background: var(--greenColor1-light);
                    color: var(--greenColor1);
                }
                &.holding{
                    background: var(--redColor2-light);
                    color: var(--redColor2);
                }
            }
        }

        .childRackLocations{
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            align-items: center;
        }

        .childRackLocationSpan{
            position: relative;
            display: block;
            padding: 3px 8px;
            border-radius: 90px;
            border:1px solid #000;
            color: #000;
            font-weight: 500;
            display: flex;
            gap: 5px;
            align-items: center;
            cursor: pointer;
            background: #fff;
            &:hover{
                .removeIcon{
                    display: block;
                }
            }

            .removeIcon{
                display: none;
                width: 15px;
                height: 15px;
                padding:0;
                border-radius: 90px;
                background: none;
            }
        }

        .copyButton{
            width: 20px;
            height: 20px;
            border: none;
            background: none;
            & > .icon{
                width: 100%;
            }
        }

        .removeButton{
            width: 20px;
            height: 20px;
            border: none;
            background: none;
            & > .icon{
                width: 100%;
            }
        }

        .loadedCountField{
            display: flex;
            gap: 5px;
            align-items: center;
        }
    `,
    TypeBadge: styled.span`
        padding: 4px 8px;
        border-radius: 9999px;
        font-size: 11px;
        font-weight: 500;
        
        ${({ type }) => type === 'EXTRA' ? `
            background-color: var(--blueColor2-light);
            color: var(--blueColor2);
        ` : type === 'HETEROMORPHIC' ? `
            background-color: var(--orangeColor1-light);
            color: var(--orangeColor1);
        ` : `
            background-color: var(--greenColor1-light);
            color: var(--greenColor1);
        `}
    `
}

export const MoveToConfirmModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px 14px 16px;

        .guide {
            font-size: 12px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 12px;
        }

        .gridWrapper {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
        }

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 14px 8px;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            background: #fff;
            cursor: pointer;
            transition: all .2s;

            .no {
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f1f5f9;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 800;
                color: #0f172a;
            }
            .label { font-size: 12px; font-weight: 700; color: #334155; }

            &:hover { border-color: #16a34a; box-shadow: 0 2px 8px rgba(22, 163, 74, .15); }

            &.newItem {
                border-style: dashed;
                border-color: #86efac;
                background: #f0fdf4;
                color: #16a34a;
                font-size: 12px;
                font-weight: 700;
                .plus { font-size: 24px; line-height: 1; }
            }
        }
    `,
}

export const AddPalletModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;

        .notice{
            font-weight: 600;
            text-align: center;
        }
        .buttons{
            display: flex;
            gap: 10px;
            width: 200px;
            margin-left: auto;
            margin-top: 20px;
            
            button{
                border: none;
                background: #efefef;
                &.add{
                    background: var(--blueColor1);
                    color: #fff;
                }

                &.delete{
                    background: var(--redColor1);
                    color: #fff;
                }
            }
        }
    `,
}

export const EditLoadItemsModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;
        .cellInput{
            background: #efefef;
            width: 100%;
            outline: none;
            transition: all .3s;
            padding: 10px;
            border: 1px solid #00000000;
            border-radius: 5px;
            font-weight: 600;
            &:focus{
                background: #fff;
                border: 1px solid #000;
            }
        }
        .quantityCell{
            width: 100%;
            height: 38.5px;
            background: #fff;
            color: #1a202c;
            border: 1px solid #cbd5e0;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 700;
            text-align: center;
        }
        .quickFillButton{
            width: 100%;
            height: 38.5px;
            background: var(--blueColor1-light, #e6efff);
            color: var(--blueColor1, #3b82f6);
            border: 1px solid var(--blueColor1, #3b82f6);
            border-radius: 5px;
            font-size: 11px;
            font-weight: 600;
        }
        .cellTextarea{
            background: #efefef;
            width: 100%;
            outline: none;
            transition: border .3s;
            padding: 10px;
            border: 1px solid #00000000;
            border-radius: 5px;
            display: block;
            white-space: pre-line;
            font-weight: 600;

            &:focus{
                background: #fff;
                border: 1px solid #000;
            }
        }

        .cellButton{
            width: 100%;
            height: 38.5px;
            background: #efefef;
        }

        td{
            padding:5px 5px;
        }

        .buttons{
            margin-top: 20px;
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            button{
                width: 100px;
                border: none;
                background: #efefef;

                &.confirm{
                    background: var(--blueColor1);
                    color: #fff;
                }
            }
        }

        .bottomButtons{
            margin-top: 10px;
            & > button{
                font-size: 10px;
                height: auto;
                width: auto;
                padding: 8px 10px;
                background: #efefef;
                border: none;
            }
        }
    `,
    PalletChangeModalContainer: styled.div`
        .header{
            padding: 10px;
        }

        .body{
            padding:10px;
            display: grid;
            grid-template-columns: repeat(4,1fr);
            gap: 10px;

            .item{
                user-select: none;
                cursor: pointer;
                aspect-ratio: 1;
                border: 1px solid #ffffffff;
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: 700;
                transition: all .3s;
                background: #efefef;

                &:hover{
                    border-color: #000;
                }

                &.selected{
                    background: var(--blueColor2-light);
                }
            }
        }
    `,
}

export const AddLoadItemsModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;
        .cellInput{
            background: #efefef;
            width: 100%;
            outline: none;
            transition: all .3s;
            padding: 10px;
            border: 1px solid #00000000;
            border-radius: 5px;
            font-weight: 600;
            &:focus{
                background: #fff;
                border: 1px solid #000;
            }
        }
        .cellTextarea{
            background: #efefef;
            width: 100%;
            outline: none;
            transition: border .3s;
            padding: 10px;
            border: 1px solid #00000000;
            border-radius: 5px;
            display: block;
            white-space: pre-line;
            font-weight: 600;

            &:focus{
                background: #fff;
                border: 1px solid #000;
            }
        }

        .addItemRow{
            position: sticky;
            bottom: 0;
            background: #fff;
        }

        .cellButton{
            width: 100%;
            height: 38.5px;
            background: #efefef;
        }

        .quickFillButton{
            width: 100%;
            height: 38.5px;
            background: var(--blueColor1-light, #e6efff);
            color: var(--blueColor1, #3b82f6);
            border: 1px solid var(--blueColor1, #3b82f6);
            border-radius: 5px;
            font-size: 11px;
            font-weight: 600;
        }

        .quantityCell{
            width: 100%;
            height: 38.5px;
            background: #fff;
            color: #1a202c;
            border: 1px solid #cbd5e0;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 700;
            text-align: center;
        }

        td{
            padding:5px 5px;
        }

        .addCellButton{
            width: 100px;
            height: 30px;
            position: sticky;
            bottom: 0;
            left: 5px;
            background: #fff;
        }

        .buttons{
            margin-top: 20px;
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            button{
                width: 100px;
                border: none;
                background: #efefef;

                &.confirm{
                    background: var(--blueColor1);
                    color: #fff;
                }
            }
        }
    `,
    PalletChangeModalContainer: styled.div`
        .header{
            padding: 10px;
        }

        .body{
            padding:10px;
            display: grid;
            grid-template-columns: repeat(4,1fr);
            gap: 10px;

            .item{
                user-select: none;
                cursor: pointer;
                aspect-ratio: 1;
                border: 1px solid #ffffffff;
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: 700;
                transition: all .3s;
                background: #efefef;

                &:hover{
                    border-color: #000;
                }

                &.selected{
                    background: var(--blueColor2-light);
                }
            }
        }
    `,
}

export const EditRackLocationAddressModal = {
    Header: styled.div`
        padding: 10px;
    `,
    BodyContainer: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .inputField{
            display: flex;
            gap: 10px;
        }
    `,
}

export const EditChildRackLocationAddressesModal = {
    BodyContainer: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
}

export const ReflectLocationModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;
        .notice{
            font-weight: 600;
            text-align: center;
        }
        .buttons{
            display: flex;
            gap: 10px;
            width: 200px;
            margin-left: auto;
            margin-top: 20px;
            
            button{
                border: none;
                background: #efefef;
                &.confirm{
                    background: var(--blueColor1);
                    color: #fff;
                }

                &.cancel{
                    background: var(--redColor1);
                    color: #fff;
                }
            }
        }
    `,
}

export const ChangeStatusModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;
        .notice{
            font-weight: 600;
            text-align: center;
        }
        .buttons{
            display: flex;
            flex-direction: column;
            gap: 10px;
            
            button{
                border: none;
                background: #efefef;
                height: 60px;

                &.loading{
                    background: var(--yellowColor1-light);
                    color: var(--yellowColor1);
                }

                &.prepared{
                    background: var(--blueColor2-light);
                    color: var(--blueColor2);
                }

                &.done{
                    background: var(--greenColor1-light);
                    color: var(--greenColor1);
                }

                &.holding{
                    background: var(--redColor2-light);
                    color: var(--redColor2);
                }
            }
        }
    `,
}

export const AutoMappingLocationModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;
        
        .stageSelection{
            .label{
                font-weight: 600;
            }

            .stageList{
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .stageItem{
                    position: relative;
                    border: 1px solid #e0e0e0;
                    padding: 10px;
                    font-size: 10px;
                    border-radius: 5px;
                    font-weight: 500;
                    transition: all .3s;

                    &:hover{
                        .blanket{
                            /* display: block; */
                            visibility: visible;
                            height: 100%;
                        }
                    }

                    .blanket{
                        /* display: none; */
                        overflow: hidden;
                        visibility: hidden;
                        position: absolute;
                        border-radius: 5px;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 0;
                        z-index: 10;
                        background: #ffffffa0;
                        transition: height 0.3s;
                        cursor: pointer;

                        .icon{
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
            }

            .notice{
                margin-top: 10px;
                font-weight: 600;
                text-align: center;
                font-size: 13px;
            }
        }

        .confirmButton{
            margin-top: 20px;
            width: 100%;
            height: 40px;
            background: var(--blueColor1);
            color: #fff;
            border: none;
        }
    `,
}